import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions'
import LoginBox from '../components/LoginBox';
import { loginAsyncThunk } from '../actions/AuthActions'
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps } from 'react-router';

interface DispatchProps {
  login: (email: string, password: string) => void
}

const mapStateToProps = (state: RootState) => {
  return ({
    isAuthenticated: state.authRdc.isAuthenticated,
    loginErrorMessage: state.authRdc.loginErrorMessage
  })
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): DispatchProps => {
  return {
    login: async (email: string, password: string) => {
      await dispatch(loginAsyncThunk(email, password))
    }
  }
}

export type LoginProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps

const LoginCnn = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginBox);

export default LoginCnn